import Swiper, { type Swiper as SwiperType } from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { updateCustomBullets } from "./swiperPagination";

class ArticlesSliderSmall {
  swiperElement: HTMLElement;
  swiperInstance: Swiper | null;

  constructor(swiperElement: HTMLElement) {
    this.swiperElement = swiperElement;
    this.swiperInstance = null;
    this.initSwiper();
  }

  initSwiper() {
    this.swiperInstance = new Swiper(this.swiperElement, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      allowTouchMove: true,
      longSwipes: true,
      longSwipesRatio: 0.2,
      speed: 300,

      pagination: {
        el: this.swiperElement.querySelector(
          ".swiper-pagination"
        ) as HTMLElement,
        clickable: true,
        dynamicBullets: false,
      },

      on: {
        init: (swiperInstance) => updateCustomBullets(swiperInstance),
        slideChange: (swiperInstance) => updateCustomBullets(swiperInstance),
        paginationUpdate: (swiperInstance) => updateCustomBullets(swiperInstance),
      },
    });
  }
}

document
  .querySelectorAll<HTMLElement>(".articles-col-swiper-small")
  .forEach((el) => {
    new ArticlesSliderSmall(el);
  });